import React from 'react'
import styled from 'styled-components'
import { Body1 } from 'src/Styles/text-styles'
import { SpeedResultState } from 'src/Common/SpeedResultState'
import { ReactComponent as CrossIcon } from 'images/cross-icon.svg'
import { ReactComponent as TickIcon } from 'images/tick-icon.svg'
import { useTheme } from 'src/Styles/theme'

interface ExpectationBulletPointProp {
  resultState: SpeedResultState
  title: string
}
const ExpectationBulletPoint = ({
  resultState,
  title,
}: ExpectationBulletPointProp) => {
  const iconWidth = 18
  const iconHeight = 18

  const Row = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 4px;
    padding-bottom: 4px;
    line-height: 25px;
  `

  const Column = styled.div`
    flex-direction: column;
    justify-content: center;
    align-item: center;
    padding-left: 4px;
    padding-right: 4px;
  `

  const Body = styled(Body1)`
    letter-spacing: 0.25px;
  `
  const { fastInnerRingColor, slowInnerRingColor } = useTheme().colors

  const getIcon = () => {
    switch (resultState) {
      case SpeedResultState.FAST:
        return (
          <TickIcon
            width={iconWidth}
            height={iconHeight}
            fill={fastInnerRingColor}
          />
        )
      case SpeedResultState.SLOW:
        return (
          <TickIcon
            width={iconWidth}
            height={iconHeight}
            fill={slowInnerRingColor}
          />
        )
      case SpeedResultState.UNSTABLE:
        return <CrossIcon width={iconWidth} height={iconHeight} />

      default:
        return (
          <TickIcon
            width={iconWidth}
            height={iconHeight}
            fill={fastInnerRingColor}
          />
        )
    }
  }

  return (
    <Row>
      <Column>{getIcon()}</Column>
      <Column>
        <Body>{title}</Body>
      </Column>
    </Row>
  )
}

export default ExpectationBulletPoint
